import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Mission from './pages/about/Mission';
import Staff from './pages/about/Staff';
import HSB from './pages/about/HSB';
import Board from './pages/about/Board';
import FAQ from './pages/about/FAQ';
import Events from './pages/Events';
import ProgramCalendar from './pages/events/ProgramCalendar';
import Holidays from './pages/events/Holidays';
import RoomReservation from './pages/events/RoomReservation';
import StudentLife from './pages/StudentLife';
import ReligiousLife from './pages/ReligiousLife';
import ProspectiveStudents from './pages/student-life/ProspectiveStudents';
import GraduateStudents from './pages/student-life/GraduateStudents';
import KosherSoupDelivery from './pages/student-life/KosherSoupDelivery';
import Parents from './pages/Parents';
import Alumni from './pages/Alumni';
import NotFound from './pages/NotFound';
import MailingList from './pages/MailingList';
import StudentGroups from './pages/student-life/StudentGroups';
import JewishLearning from './pages/student-life/JewishLearning';
import TravelOpportunities from './pages/travel/TravelOpportunities';
import InternshipOpportunities from './pages/student-life/InternshipOpportunities';
import Opportunities from './pages/student-life/Opportunities';
import ParentGetConnected from './pages/parents/ParentGetConnected';
import StayInformed from './pages/parents/StayInformed';
import SitePage from './pages/SitePage';
import StandaloneFormPage from './pages/StandaloneFormPage';
import sitePages from './cms/site-pages.json';

// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import global styles
import './css/global/global.css';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/staff/:staffId" element={<Staff />} />
          <Route path="/student-board" element={<HSB />} />
          <Route path="/student-board/:hsbId" element={<HSB />} />
          <Route path="/board" element={<Board />} />
          <Route path="/board/:boardId" element={<Board />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/events" element={<Events />} />
          <Route path="/program-calendar" element={<ProgramCalendar />} />
          <Route path="/holidays" element={<Holidays />} />
          <Route path="/holidays/:holidayId" element={<Holidays />} />
          <Route path="/room-reservation" element={<RoomReservation />} />
          <Route path="/student-life" element={<StudentLife />} />
          <Route path="/religious-life" element={<ReligiousLife />} />
          <Route path="/prospective-students" element={<ProspectiveStudents />} />
          <Route path="/shabbatons/:shabbatonId" element={<ProspectiveStudents />} />
          <Route path="/graduate-students" element={<GraduateStudents />} />
          <Route path="/kosher-soup-delivery" element={<KosherSoupDelivery />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/mailing-list" element={<MailingList />} />
          <Route path="/student-groups" element={<StudentGroups />} />
          <Route path="/jewish-learning" element={<JewishLearning />} />
          <Route path="/travel-opportunities" element={<TravelOpportunities />} />
          <Route path="/internship-opportunities" element={<InternshipOpportunities />} />
          <Route path="/student-life-opportunities" element={<Opportunities />} />
          <Route path="/get-connected" element={<Home />} />
          <Route path="/parents/get-connected" element={<ParentGetConnected />} />
          <Route path="/parents/stay-informed" element={<StayInformed />} />
          <Route path="/schedule-tour" element={<ProspectiveStudents />} />
          {sitePages
            .filter((p) => p.enabled && p.shortUrl)
            .map((p) => (
              <Route
                key={`short-${p.shortUrl}`}
                path={`/${p.shortUrl}`}
                element={<SitePage pageSlug={p.slug} />}
              />
            ))}
          <Route path="/pages/:slug" element={<SitePage />} />
          <Route path="/forms/:formKey" element={<StandaloneFormPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Analytics />
      </Layout>
    </Router>
  );
};

export default App;